import { createSlice } from '@reduxjs/toolkit';
import { IOrder } from '../../../../dto';
import { setOrders } from '../actions';
import { MN_ORDERS, TYPE_LIST } from '../../../../common';

export interface OrdersState {
  data: IOrder[];
  loading: boolean;
  error: string | null;
}

const initialState: OrdersState = {
  data: [],
  loading: false,
  error: null,
};

export const ordersSlice = createSlice({
  name: `${MN_ORDERS}/${TYPE_LIST}`,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setOrders, (state, { payload }) => {
      state.data = payload;
    });
  },
});
